import { NavLink } from "react-router-dom";
import { Container, Button } from "react-bootstrap";

const LookingFor = () => {
  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">


<div className="col-12 col-md-8 col-lg-7 ">
<div className="card p-5 shadow-sm border-0 rounded-4">
  <div className="p-4">
  <h3 className="form-header text-center mb-2">
      What are you looking for?
  </h3>
  <p className="text-muted text-center mb-4">
  Easily connect with top professionals or businesses tailored to your needs. Whether you're hiring or growing your business.
  </p>


  <NavLink to="/CreateCompanyProfileSearch" className="d-block mb-3">
          <Button
            variant="primary"
            size="lg"
            className="w-100 py-3 rounded-3 fw-medium"
          >
            Create Company Profile
          </Button>
        </NavLink>

        <h5 className="fs-5 mb-3 text-muted fw-normal text-center">
          or
        </h5>

        <NavLink to="/PostLead" className="d-block">
          <Button
            variant="outline-primary text-primary"
            size="lg"
            className="w-100 py-3 rounded-3 fw-medium border-2"
          >
            I Want to Hire
          </Button>
    </NavLink>


</div>
</div>
</div>

    </Container>
  );
};

export default LookingFor;
